import {useCallback, useEffect, useState} from "react";

import Grid from '@mui/material/Grid';

import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCityTimezone} from 'ultra/configs/general';
import {getClientCity} from 'ultra/configs/general';
import {isLibrary} from 'ultra/helpers/auth'; // isAdmin
import {getFormatedDate, timestampToDate} from 'ultra/helpers/date'

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import Button from '@mui/material/Button';

import AdaptiveDialog from '../../../../../../../../../Components/Adaptive/Dialog';

import FormContainer from '../../../../../../../../../Components/Form/FormContainer';

import {NODE_ACTIONS} from '../../../../../../../Reducers/node';
import {useToasterStore} from '../../../../../../../../../Stores/toster';
import {useConfigStore} from '../../../../../../../../../Stores/config';
import {useBackdropPreloaderStore} from '../../../../../../../../../Stores/backdropPreloader';
// import {isYoursAccount} from '../../../../../../../../../Helpers/user';
import {useGlobalCustomContext} from '../../../../../../../../../Helpers/context';
import {ownerApproveReturnBook, extendReadingTerm} from '../../../../../../../../../Helpers/library';
import {getBookStatuscode} from '../../../../../../../Helpers/library'

import ReaderDetails from '../ReaderDetails';

export default function BookIsReading(props) {
    const {book} = props;
    const {showBackdropPreloader, hideBackdropPreloader} = useBackdropPreloaderStore();
    const {userState, nodeDispatch} = useGlobalCustomContext();

    const {configs} = useConfigStore();

    const {showPromt, showSuccess, closeToaster} = useToasterStore();

    const [timeZone, setTimeZone] = useState()
    const [isExtendPopupOpen, setIsExtendPopupOpen] = useState();
    const [extendFormConfig, setExtendFormConfig] = useState();

    useEffect(() => {
        const city = getClientCity(window) || DEFAULT_CITY;
        setTimeZone(getClientCityTimezone(configs, city));

        if (!extendFormConfig && getBookStatuscode(book) === 'overdue') {
            setExtendFormConfig({
                fields: {
                    term: {
                        type: 'number',
                        placeholder: 'Кількість тижнів',
                        required: true,
                    }
                },
                form: {
                    submitText: "Продовжити термін",
                }
            })
        }
    }, [configs, book])

    // const [hasFullAccess] = useState(isAdmin(userState?.user) || isLibrary(userState?.user));
    // const [isOwner, setIsOwner] = useState();

    // useEffect(() => {
    //     setIsOwner(isYoursAccount(userState, book?._created_by))
    // }, [userState?.user?.id, book])

    const returnBookHandle = () => {
        const city = getClientCity(window) || DEFAULT_CITY;
        showBackdropPreloader();
        
        showPromt({
            snackbarMessage: 'Це примусова дія, доступна лише для бібліотекаря і має використовуватись лише в екстрених випадках. Бажаєте продовжити?',
            snackbarDuration: 10000,
            onApproveHandler: async () => {
                closeToaster();
                // hideBackdropPreloader();
                await ownerApproveReturnBook(city, book._uri)
                nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START});
                showSuccess({
                    snackbarMessage: 'Книгу було успішно повернуто до бібліотеки'
                })
            },
        })
    }

    const onExtendTerm = useCallback(() => {
        setIsExtendPopupOpen(true);
    }, [])

    const handleExtendDialogClose = () => {
        setIsExtendPopupOpen(false);
    }

    const onExtendSubmit = (data) => {
        showBackdropPreloader();
        const city = getClientCity(window) || DEFAULT_CITY;
        extendReadingTerm(city, book._uri, data.term)
            .then(() => {
                handleExtendDialogClose();
                hideBackdropPreloader();
                nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START});
            })
    }

    return <>
        <div className="text">
            <p>
                <span>Книга зайнята до </span>
                {getFormatedDate(timestampToDate(book?._reading_till), timeZone)}
            </p>
            {getBookStatuscode(book) === 'overdue' && <p>
                Прострочено термін повернення
                {isLibrary(userState?.user) && <span> (<span className="pseudoLink" onClick={onExtendTerm}>продовжити</span>)</span>}
            </p>}
        </div>
        
        {/* INFO: Доступно лише для бібліотеки, хоча API дозволяє власнику теж це робити */}
        {isLibrary(userState?.user) && <Grid container spacing={2}>
            {/* isLibrary(userState?.user) ? 6 : 12 */}
            <Grid item xs={6}>
                <ReaderDetails book={book} fullWidth />
            </Grid>
            {/* {isLibrary(userState?.user)  */}
            <Grid item xs={6}>
                <Button className="errorButton" startIcon={<CheckCircleOutlineOutlinedIcon />} variant="outlined" fullWidth onClick={returnBookHandle}>Повернути</Button>
            </Grid>
        </Grid>}

        <AdaptiveDialog
            open={isExtendPopupOpen}
            onClose={handleExtendDialogClose}
            title={'Продовжити термін'}
        >
            <FormContainer
                config={extendFormConfig}
                submitHandler={onExtendSubmit}
            />
        </AdaptiveDialog>
    </>
}
